var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBpPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 64,
    viewBox: "0 0 43 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.07 0.00312805C9.47235 0.00312805 0.0348511 9.44063 0.0348511 21.0383C0.0348511 25.7102 3.01923 33.3273 9.15594 44.3234C13.4958 52.1008 17.7653 58.5852 17.945 58.8586L21.07 63.5969L24.1989 58.8586C24.3747 58.5852 28.6442 52.1008 32.9841 44.3234C39.1208 33.3273 42.1052 25.7102 42.1052 21.0383C42.1052 9.44063 32.6677 0.00312805 21.07 0.00312805ZM21.07 31.8C15.0466 31.8 10.1677 26.9172 10.1677 20.8977C10.1677 14.8742 15.0466 9.99141 21.07 9.99141C27.0934 9.99141 31.9724 14.8742 31.9724 20.8977C31.9724 26.9172 27.0934 31.8 21.07 31.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4489 21.175C38.4489 30.7727 30.6677 38.5539 21.07 38.5539C11.4724 38.5539 3.6911 30.7727 3.6911 21.175C3.6911 11.5734 11.4724 3.79219 21.07 3.79219C30.6677 3.79219 38.4489 11.5734 38.4489 21.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 38C30.3888 38 38 30.3888 38 21C38 11.6112 30.3888 4 21 4C11.6112 4 4 11.6112 4 21C4 30.3888 11.6112 38 21 38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3877 9.49765C22.8201 8.17921 22.1206 6.92155 21.2998 5.74388C20.484 6.9246 19.7848 8.18176 19.212 9.49765C20.0226 10.3563 20.7239 11.3119 21.2998 12.3428C21.8704 11.3085 22.5722 10.3522 23.3877 9.49765Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2228 33.1129C19.7904 34.4313 20.49 35.689 21.3107 36.8666C21.6785 36.3041 22.6305 34.9194 23.3985 33.1129C22.5913 32.2514 21.8904 31.2962 21.3107 30.2678C20.7311 31.2962 20.0301 32.2514 19.2228 33.1129Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2228 9.4976C18.2326 8.4561 17.146 7.51073 15.9775 6.67417C15.6139 8.06196 15.3892 9.48247 15.3068 10.9148C16.3611 11.4438 17.3458 12.1015 18.2384 12.8728C18.4229 11.7107 18.7536 10.5766 19.2228 9.4976Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3877 33.1129C24.3754 34.157 25.4622 35.1027 26.633 35.9363C26.9957 34.5484 27.2204 33.1279 27.3038 31.6958C26.2517 31.1627 25.2675 30.5054 24.3721 29.7377C24.1811 30.8983 23.8505 32.0316 23.3877 33.1129Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3068 10.9147C14.0235 10.27 12.6791 9.75541 11.2933 9.37856C11.4286 10.8084 11.704 12.2215 12.1155 13.5975C13.2851 13.7321 14.4335 14.0119 15.5339 14.4305C15.3161 13.272 15.2398 12.0915 15.3068 10.9147Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2929 31.6957C28.5761 32.3404 29.9206 32.855 31.3063 33.2319C31.1711 31.802 30.8957 30.3889 30.4842 29.0129C29.3141 28.8744 28.1658 28.591 27.0657 28.1691C27.294 29.3299 27.3704 30.5153 27.2929 31.6957Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5327 16.8213C12.9305 15.8085 12.4546 14.7259 12.1156 13.5975C10.69 13.4305 9.25143 13.4051 7.82086 13.5218C8.43933 14.8144 9.17821 16.0459 10.0277 17.1999C11.1755 16.9269 12.3531 16.7998 13.5327 16.8213Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.067 25.7892C29.6736 26.7996 30.1498 27.8828 30.4842 29.0129C31.9097 29.18 33.3483 29.2053 34.7788 29.0886C34.158 27.7916 33.4155 26.5564 32.5612 25.3998C31.4177 25.6776 30.2436 25.8085 29.067 25.7892Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0277 17.1999C8.63427 17.5353 7.27591 18.0026 5.97104 18.5954C6.99525 19.6028 8.11472 20.5085 9.31375 21.2999C10.2974 20.6505 11.3586 20.1272 12.4725 19.7421C11.5577 18.9969 10.7367 18.1432 10.0277 17.1999Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2968 21.2998C32.3132 21.9491 31.2519 22.4724 30.138 22.8575C31.0523 23.6 31.87 24.4541 32.572 25.3997C33.9666 25.0682 35.3253 24.6007 36.6287 24.0042C35.6115 22.9934 34.4953 22.0874 33.2968 21.2998Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4725 22.8575C11.3586 22.4724 10.2974 21.9491 9.31375 21.2998C8.11472 22.0911 6.99525 22.9968 5.97104 24.0042C7.27393 24.6021 8.63278 25.0695 10.0277 25.3997C10.7395 24.4589 11.5602 23.6055 12.4725 22.8575Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.138 19.7421C31.2511 20.1295 32.312 20.6527 33.2968 21.2999C34.4958 20.5085 35.6153 19.6028 36.6395 18.5954C35.3366 17.9976 33.9778 17.5302 32.5829 17.1999C31.8739 18.1432 31.0529 18.9969 30.138 19.7421Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0277 25.4106C9.16919 26.5624 8.42977 27.7984 7.82086 29.0995C9.25158 29.2105 10.6896 29.1851 12.1156 29.0238C12.4546 27.8954 12.9305 26.8128 13.5327 25.8001C12.3532 25.8073 11.1769 25.6766 10.0277 25.4106Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5721 17.1999C33.4287 16.0448 34.1714 14.8094 34.7897 13.511C33.359 13.4001 31.921 13.4254 30.495 13.5868C30.156 14.7151 29.6801 15.7978 29.0779 16.8105C30.2541 16.7978 31.4275 16.9286 32.5721 17.1999Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5339 28.1691C14.4322 28.5859 13.2846 28.8692 12.1155 29.0129C11.704 30.3889 11.4286 31.802 11.2933 33.2319C12.6791 32.855 14.0235 32.3404 15.3068 31.6957C15.2401 30.5153 15.3164 29.3312 15.5339 28.1691Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0657 14.4305C28.1662 14.0119 29.3145 13.7321 30.4842 13.5975C30.8957 12.2215 31.1711 10.8084 31.3063 9.37856C29.9206 9.75541 28.5761 10.27 27.2929 10.9147C27.3704 12.0915 27.294 13.2734 27.0657 14.4305Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3068 31.6957C15.3892 33.128 15.6139 34.5486 15.9775 35.9363C17.1487 35.1032 18.2357 34.1576 19.2228 33.1129C18.7536 32.0301 18.4229 30.8925 18.2384 29.7269C17.346 30.5014 16.3614 31.1627 15.3068 31.6957Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.293 10.9148C27.2106 9.48247 26.9859 8.06196 26.6222 6.67417C25.451 7.50728 24.364 8.45293 23.3769 9.4976C23.8397 10.5789 24.1703 11.7122 24.3613 12.8728C25.2585 12.1075 26.2424 11.4504 27.293 10.9148Z",
    fill: "#009900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2289 15.2526C20.4287 14.2283 20.7901 13.2424 21.2999 12.3318C20.7239 11.3009 20.0226 10.3453 19.2121 9.48671C18.7443 10.5662 18.4135 11.7001 18.2276 12.8619C19.0159 13.5489 19.6913 14.3557 20.2289 15.2526Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3708 27.3578C22.1693 28.3815 21.8079 29.3672 21.2999 30.2786C21.8722 31.3118 22.5738 32.2678 23.3877 33.1237C23.852 32.0392 24.1826 30.9021 24.3722 29.7377C23.5815 29.0571 22.9058 28.2534 22.3708 27.3578Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.534 14.4305C16.5075 14.8016 17.4165 15.3236 18.2276 15.9774C18.0653 14.9489 18.0653 13.9012 18.2276 12.8727C17.3341 12.1027 16.3495 11.4451 15.296 10.9147C15.2382 12.0919 15.3181 13.2718 15.534 14.4305Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0658 28.1691C26.0923 27.798 25.1833 27.276 24.3721 26.6222C24.5363 27.6508 24.5327 28.6994 24.3613 29.7269C25.2548 30.4969 26.2394 31.1545 27.293 31.6849C27.37 30.5081 27.2937 29.3262 27.0658 28.1691Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5941 17.3513C16.0892 16.4396 15.7313 15.4538 15.534 14.4305C14.4335 14.0119 13.2852 13.7321 12.1155 13.5975C12.4546 14.7259 12.9305 15.8085 13.5326 16.8212C14.5749 16.833 15.6085 17.012 16.5941 17.3513Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0056 25.2592C26.5106 26.1709 26.8684 27.1566 27.0657 28.18C28.1674 28.5968 29.3151 28.8801 30.4842 29.0238C30.1451 27.8954 29.6692 26.8128 29.0671 25.8C28.0254 25.7719 26.9938 25.5897 26.0056 25.2592Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4725 19.742C13.4581 19.4015 14.4914 19.2189 15.534 19.2012C14.7463 18.5206 14.0741 17.7169 13.5435 16.8213C12.3642 16.8051 11.1872 16.9323 10.0385 17.1999C10.7406 18.1455 11.5583 18.9996 12.4725 19.742Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.138 22.8576C29.1525 23.1981 28.1192 23.3807 27.0766 23.3985C27.8643 24.0791 28.5365 24.8828 29.0671 25.7784C30.2472 25.797 31.4249 25.6662 32.572 25.389C31.864 24.4516 31.0469 23.6018 30.138 22.8576Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1553 21.2998C14.1832 20.928 13.2773 20.402 12.4725 19.742C11.3586 20.1271 10.2974 20.6504 9.31375 21.2998C10.2974 21.9491 11.3586 22.4724 12.4725 22.8575C13.28 22.2014 14.1853 21.6758 15.1553 21.2998Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4444 21.2998C28.4187 21.6739 29.3278 22.1997 30.138 22.8575C31.251 22.4702 32.312 21.947 33.2968 21.2998C32.3132 20.6504 31.252 20.1271 30.138 19.742C29.332 20.4059 28.4218 20.9323 27.4444 21.2998Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5327 25.7892C14.0667 24.896 14.7384 24.0928 15.5231 23.4093C14.4805 23.3915 13.4473 23.209 12.4617 22.8684C11.5474 23.6109 10.7297 24.4649 10.0277 25.4106C11.1764 25.6782 12.3533 25.8053 13.5327 25.7892Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0671 16.8213C28.5331 17.7145 27.8613 18.5177 27.0766 19.2012C28.1192 19.2189 29.1525 19.4015 30.138 19.7421C31.0523 18.9996 31.87 18.1456 32.572 17.1999C31.4244 16.9264 30.2467 16.7992 29.0671 16.8213Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5941 25.2592C15.6085 25.5984 14.5749 25.7774 13.5326 25.7892C12.9305 26.8019 12.4546 27.8846 12.1155 29.0129C13.2856 28.8744 14.4338 28.591 15.534 28.1691C15.7332 27.1497 16.0909 26.1678 16.5941 25.2592Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0056 17.3513C26.9912 17.012 28.0248 16.833 29.0671 16.8212C29.6736 15.8108 30.1498 14.7276 30.4842 13.5975C29.3145 13.7321 28.1662 14.0119 27.0657 14.4305C26.8733 15.4552 26.5152 16.4417 26.0056 17.3513Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2289 27.3578C19.694 28.2534 19.0182 29.0571 18.2276 29.7377C18.4135 30.903 18.7443 32.0404 19.2121 33.1237C20.0226 32.265 20.7239 31.3094 21.2999 30.2786C20.7965 29.3651 20.4354 28.3802 20.2289 27.3578Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2276 26.633C17.418 27.289 16.5086 27.8112 15.5339 28.1799C15.3111 29.3377 15.2347 30.5189 15.3068 31.6957C16.3588 31.1627 17.3431 30.5053 18.2384 29.7377C18.067 28.7102 18.0634 27.6617 18.2276 26.633Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3708 15.2527C22.9091 14.3595 23.5845 13.5564 24.3722 12.8728C24.1877 11.7107 23.8569 10.5767 23.3877 9.49765C22.5805 10.3591 21.8795 11.3143 21.2999 12.3427C21.8113 13.2487 22.1729 14.2314 22.3708 15.2527Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3721 15.9774C25.1802 15.3192 26.09 14.7967 27.0658 14.4305C27.2886 13.2727 27.365 12.0915 27.293 10.9147C26.2409 11.4477 25.2567 12.1051 24.3613 12.8727C24.5327 13.9002 24.5363 14.9487 24.3721 15.9774Z",
    fill: "#99CC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2397 18.3899C19.73 17.4672 19.0468 16.6517 18.2276 15.9884C18.4013 17.0265 18.7643 18.0239 19.2986 18.9308C18.5028 18.2438 17.5856 17.7118 16.5942 17.3622C17.1104 18.2803 17.7927 19.0947 18.6063 19.7637C17.6226 19.3869 16.5765 19.1997 15.5232 19.212C16.3219 19.898 17.2432 20.4265 18.2384 20.7698C17.1858 20.7533 16.1395 20.9369 15.1554 21.3107C16.1415 21.6775 17.1863 21.8608 18.2384 21.8516C17.2432 22.1949 16.3219 22.7234 15.5232 23.4094C16.5765 23.4217 17.6226 23.2345 18.6063 22.8576C17.7903 23.5243 17.1076 24.3391 16.5942 25.2592C17.5847 24.9078 18.5017 24.376 19.2986 23.6906C18.7597 24.5953 18.3963 25.5936 18.2276 26.6331C19.039 25.9617 19.7208 25.1479 20.2397 24.2315C20.0449 25.2681 20.0449 26.332 20.2397 27.3687C20.7753 26.4624 21.1384 25.4647 21.3107 24.4262C21.4811 25.4652 21.8444 26.4632 22.3816 27.3687C22.5765 26.332 22.5765 25.2681 22.3816 24.2315C22.8977 25.1499 23.58 25.9642 24.3938 26.6331C24.2211 25.5931 23.8541 24.5948 23.312 23.6906C24.1116 24.3779 25.0325 24.9099 26.0273 25.2592C25.5138 24.3391 24.8312 23.5243 24.0152 22.8576C24.9988 23.2345 26.0449 23.4217 27.0982 23.4094C26.2974 22.7238 25.3769 22.192 24.383 21.8408C25.4356 21.8573 26.4818 21.6737 27.466 21.2999C26.4802 20.9321 25.4351 20.7488 24.383 20.759C25.3782 20.4157 26.2995 19.8872 27.0982 19.2012C26.0449 19.1888 24.9988 19.376 24.0152 19.7529C24.8343 19.0866 25.5206 18.2719 26.0381 17.3514C25.0433 17.7007 24.1224 18.2327 23.3228 18.9199C23.8649 18.0157 24.2319 17.0176 24.4046 15.9775C23.5933 16.6488 22.9114 17.4627 22.3925 18.3791C22.5874 17.3424 22.5874 16.2785 22.3925 15.2419C21.8552 16.1474 21.492 17.1453 21.3215 18.1844C21.151 17.1453 20.7878 16.1474 20.2505 15.2419C20.0465 16.2809 20.0428 17.3494 20.2397 18.3899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2397 18.3898C20.0448 17.3531 20.0448 16.2893 20.2397 15.2526C19.7048 14.3569 19.029 13.5534 18.2384 12.8727C18.0707 13.9008 18.0707 14.9493 18.2384 15.9774C19.0461 16.6537 19.7242 17.4711 20.2397 18.3898Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.36 24.2207C22.5549 25.2573 22.5549 26.3212 22.36 27.3579C22.8983 28.2511 23.5736 29.0543 24.3613 29.7378C24.5273 28.7098 24.531 27.6622 24.3721 26.6331C23.5581 25.9602 22.8759 25.1422 22.36 24.2207Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2276 15.9776C17.4179 15.3215 16.5086 14.7993 15.5339 14.4306C15.7264 15.4553 16.0844 16.4418 16.5941 17.3514C17.5866 17.6985 18.5044 18.2308 19.2985 18.92C18.7626 18.0139 18.3994 17.0162 18.2276 15.9776Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3722 26.633C25.1802 27.2912 26.09 27.8137 27.0658 28.1799C26.8733 27.1552 26.5152 26.1687 26.0056 25.2591C25.0128 24.9055 24.0927 24.3739 23.2904 23.6905C23.8388 24.5917 24.2063 25.5912 24.3722 26.633Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6171 19.7528C17.8011 19.0862 17.1184 18.2714 16.6049 17.3513C15.6194 17.012 14.5858 16.833 13.5435 16.8212C14.0775 17.7144 14.7493 18.5176 15.534 19.2012C16.5872 19.1897 17.6332 19.3768 18.6171 19.7528Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9935 22.8576C24.8095 23.5242 25.4922 24.339 26.0056 25.2591C26.9912 25.5984 28.0248 25.7774 29.0671 25.7892C28.5331 24.896 27.8613 24.0928 27.0766 23.4093C26.0233 23.4217 24.9772 23.2344 23.9935 22.8576Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2384 20.7697C17.2431 20.4264 16.3218 19.8979 15.5231 19.2119C14.4805 19.2297 13.4473 19.4123 12.4617 19.7528C13.268 20.4106 14.1735 20.9364 15.1445 21.3106C16.1318 20.9344 17.182 20.7508 18.2384 20.7697Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3613 21.8407C25.3553 22.1919 26.2758 22.7237 27.0766 23.4093C28.1192 23.3915 29.1525 23.209 30.138 22.8684C29.3293 22.2083 28.4198 21.6824 27.4444 21.3106C26.4595 21.6808 25.4133 21.8606 24.3613 21.8407Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1553 21.2998C14.1832 21.6716 13.2773 22.1976 12.4725 22.8575C13.4581 23.1981 14.4913 23.3807 15.5339 23.3984C16.3326 22.7125 17.2539 22.1839 18.2493 21.8407C17.1927 21.8615 16.1421 21.6778 15.1553 21.2998Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4444 21.2998C28.4187 20.9256 29.3278 20.3999 30.138 19.742C29.1525 19.4015 28.1192 19.2189 27.0766 19.2012C26.2779 19.8871 25.3566 20.4156 24.3613 20.7589C25.4136 20.7479 26.4588 20.9312 27.4444 21.2998Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6171 22.8576C17.6334 23.2344 16.5873 23.4217 15.534 23.4093C14.7463 24.0899 14.0741 24.8936 13.5435 25.7892C14.5853 25.7721 15.6181 25.5933 16.6049 25.2591C17.1114 24.3343 17.7952 23.5182 18.6171 22.8576Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9935 19.7528C24.9772 19.3759 26.0233 19.1887 27.0766 19.2012C27.8643 18.5206 28.5365 17.7168 29.0671 16.8212C28.0253 16.8383 26.9925 17.0171 26.0056 17.3513C25.4922 18.2714 24.8095 19.0862 23.9935 19.7528Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2289 27.3578C20.4305 28.3815 20.7919 29.3672 21.2998 30.2786C21.805 29.3659 22.1662 28.3807 22.3708 27.3578C21.8352 26.4515 21.4721 25.4539 21.2998 24.4154C21.1325 25.4552 20.7691 26.4537 20.2289 27.3578Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2397 24.2207C19.7271 25.1414 19.0443 25.9564 18.2276 26.6223C18.0653 27.6508 18.0653 28.6984 18.2276 29.727C19.0153 29.0434 19.6906 28.2403 20.2289 27.3471C20.0432 26.3129 20.0469 25.2535 20.2397 24.2207Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5941 25.2591C16.0891 26.1708 15.7313 27.1566 15.5339 28.1799C16.5074 27.8088 17.4165 27.2868 18.2276 26.633C18.4012 25.5948 18.7642 24.5974 19.2985 23.6905C18.5016 24.3759 17.5847 24.9077 16.5941 25.2591Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3708 15.2526C22.1711 14.2284 21.8096 13.2424 21.2998 12.3318C20.7931 13.2438 20.4317 14.2292 20.2289 15.2526C20.7662 16.1581 21.1294 17.1561 21.2998 18.1951C21.4703 17.1561 21.8335 16.1581 22.3708 15.2526Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.36 18.3898C22.8731 17.4694 23.5558 16.6546 24.3721 15.9882C24.5363 14.9595 24.5327 13.911 24.3613 12.8835C23.5736 13.5671 22.8983 14.3702 22.36 15.2635C22.5658 16.2954 22.5658 17.3578 22.36 18.3898Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0056 17.3514C26.5106 16.4397 26.8684 15.454 27.0658 14.4306C26.0923 14.8017 25.1833 15.3237 24.3722 15.9776C24.1995 17.0176 23.8325 18.0158 23.2904 18.92C24.0927 18.2366 25.0128 17.7051 26.0056 17.3514Z",
    fill: "#FFE600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.12,
    height: 63.6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpPin);
export default __webpack_public_path__ + "bpPin.2eb7bef.svg";
export { ForwardRef as ReactComponent };